
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/bank-transfer-invoices",
      function () {
        return require("private-next-pages/admin/bank-transfer-invoices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/bank-transfer-invoices"])
      });
    }
  